import { render, staticRenderFns } from "./CoursewareSearchWidget.vue?vue&type=template&id=7c260ba3&"
import script from "./CoursewareSearchWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareSearchWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c260ba3')) {
      api.createRecord('7c260ba3', component.options)
    } else {
      api.reload('7c260ba3', component.options)
    }
    module.hot.accept("./CoursewareSearchWidget.vue?vue&type=template&id=7c260ba3&", function () {
      api.rerender('7c260ba3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/courseware/CoursewareSearchWidget.vue"
export default component.exports